import {EventItem, Race} from "@model";
import {getLanguageValue} from "@utility";

export class LeagueEvents {
    constructor(
        public events: EventItem[] = [],
        public templateEvents: EventItem[] = [],
        public pendingEvents: EventItem[] = [],
        public upcoming: EventItem[] = [],
        public finished: EventItem[] = [],
        public nextRound?: EventItem,
        public total?: number,
        public finishedRounds?: number,
        public totalRounds?: number) {
    }

    getAllEvents(): EventItem[] {
        return [...this.events, ...this.templateEvents];
    }

    getRaceNames(filterTemplates: boolean = true): Map<number, string> {
        const names = new Map<number, string>();

        const allEvents = [
            ...(this.events ?? []),
            ...(!filterTemplates ? (this.templateEvents ?? []) : [])
        ];

        allEvents.forEach((e: EventItem) => {
            e.racesList?.forEach((r: Race) => {
                if (r.id) {
                    names.set(r.id, getLanguageValue(r.name, r.nameEng, r.nameIta, r.nameSlo, r.nameSr, r.nameBs, r.name ?? '') ?? '-');
                }
            });
        });

        return names;
    }
}